module.exports = __webpack_public_path__ + "img/mild-smiley.63468f6c.webp";